import { Gender } from '__generated__/api';
import i18n from 'i18next';

const getGenderStatusValue = (genderStatus?: Gender | undefined) =>
  genderStatus ? i18n.t(`general.enumerations.gender.${genderStatus}`) : undefined;

export default getGenderStatusValue;
